import { render } from "./addInStore.vue?vue&type=template&id=8fbcd984&scoped=true"
import script from "./addInStore.vue?vue&type=script&lang=js"
export * from "./addInStore.vue?vue&type=script&lang=js"

import "./addInStore.vue?vue&type=style&index=0&id=8fbcd984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fbcd984"]])

export default __exports__